import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getStorage,
  getDownloadURL,
  deleteObject,
  ref,
} from "firebase/storage";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  Auth,
  UserCredential,
} from "firebase/auth";
import { Firestore, getFirestore } from "firebase/firestore";
import "firebase/database";
// import "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase
export const auth: Auth = getAuth(app);
// initialize cloud forestore and get a reference to the service
export const db: Firestore = getFirestore(app);

const analytics = getAnalytics(app);

const provider: GoogleAuthProvider = new GoogleAuthProvider();
// const analytics = getAnalytics(app);

// https://firebase.google.com/docs/auth/web/auth-state-persistence
export async function googleSignIn(): Promise<UserCredential> {
  return await signInWithPopup(auth, provider);
}

/////////////////////////////////////////////
// Storage
export const storage = getStorage(app);

export function downloadFileStorage(
  response: any,
): Promise<string> {
  const fileRef = ref(storage, response);
  return getDownloadURL(fileRef);
}

// exported to storageModule
export function deleteFile(path: any):Promise<void> {
  const fileRef = ref(storage, path);
  return deleteObject(fileRef);
}